import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=02a8f8ac&scoped=true&"
import script from "./brandList.vue?vue&type=script&lang=js&"
export * from "./brandList.vue?vue&type=script&lang=js&"
import style0 from "./brandList.vue?vue&type=style&index=0&id=02a8f8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a8f8ac",
  null
  
)

export default component.exports